import React from 'react';
import { Preview2d } from '@gift/ui/components/preview/Preview2d';
import { Paintable } from 'ff-canvas';
import { WebsiteState } from '@gift/website-state/store';
import { Grid } from '@gift/ui/components/grid/Grid';
import { selectPaintablesForPreview } from '../_redux-variants';
import { connect } from 'react-redux';
import { TransformParameters } from '@gift/common/helpers/transformParameters';
import { selectTransformParametersForPreview } from '@gift/basic-scene-website/_redux-prefabs';

const _BasicPreview2d = ({ paintables, transformParameters }: Props) => {

    const sceneRatio = transformParameters.sceneHeight / transformParameters.sceneWidth;
    const containerWidth = Math.min(100, 1 / (sceneRatio) * 100);

    return (
        <Grid justify='center'>
            <div style={{ width: `${containerWidth}%` }}>
                <Preview2d
                    paintables={paintables}
                    transformParameters={transformParameters} />
            </div>
        </Grid>
    );
};

type Props = {
    paintables: Paintable[],
    transformParameters: TransformParameters
};

const mapStateToProps = (state: WebsiteState) => ({
    paintables: selectPaintablesForPreview(state, 'mockup'),
    transformParameters: selectTransformParametersForPreview(state)
});

export const BasicPreview2d = connect(
    mapStateToProps
)(_BasicPreview2d);
